var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtractArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5.41421V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V5.41421L15.2929 7.70711C15.6834 8.09763 16.3166 8.09763 16.7071 7.70711C17.0976 7.31658 17.0976 6.68342 16.7071 6.29289L12.7071 2.29289C12.3166 1.90237 11.6834 1.90237 11.2929 2.29289L7.29289 6.29289C6.90237 6.68342 6.90237 7.31658 7.29289 7.70711C7.68342 8.09763 8.31658 8.09763 8.70711 7.70711L11 5.41421ZM2 4C1.44772 4 1 4.44772 1 5C1 5.55228 1.44772 6 2 6H3V17C3 18.6569 4.34315 20 6 20H18C19.6569 20 21 18.6569 21 17V6H22C22.5523 6 23 5.55228 23 5C23 4.44772 22.5523 4 22 4H20C19.4477 4 19 4.44772 19 5V17C19 17.5523 18.5523 18 18 18H6C5.44772 18 5 17.5523 5 17V5C5 4.44772 4.55228 4 4 4H2Z",
    fill: "#9090AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtractArchive);
export default __webpack_public_path__ + "static/media/Extract_Archive.84d1b3ab927b57e321935cf1e61220b0.svg";
export { ForwardRef as ReactComponent };